export enum CommonBlockComponent {
  SectionEvent = 'SectionEvent',
}

export enum MainPageBlockComponent {
  SectionTopic = 'SectionTopic',
  Section2Cards = 'Section2Cards',
  Section3Cards = 'Section3Cards',
  Section4Cards = 'Section4Cards',
  SectionNews = 'SectionNews',
  SectionReadOften = 'SectionReadOften',
  SectionRecent = 'SectionRecent',
}

export enum ArticlePageBlockComponent {
  SectionImportant = 'SectionImportant',
  SectionQuotes = 'SectionQuotes',
  SectionTextBgColor = 'SectionTextBgColor',
  SectionText = 'SectionText',
  SectionImages = 'SectionImages',
  SectionDivider = 'SectionDivider',
  SectionBanner = 'SectionBanner',
  SectionAccordion = 'SectionAccordion',
  SectionForm = 'SectionForm',
  SectionSubscribe = 'SectionSubscribe',
  YoutubeVideo = 'YoutubeVideo',
  VkVideo = 'VkVideo',
  SectionFaq = 'SectionFaq',
}
